import { render } from "./Citations.vue?vue&type=template&id=0fcd9246&scoped=true"
import script from "./Citations.vue?vue&type=script&lang=js"
export * from "./Citations.vue?vue&type=script&lang=js"

import "./Citations.vue?vue&type=style&index=0&id=0fcd9246&scoped=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcd9246"]])

export default __exports__